import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from 'utils/react';
import styles from './InlineInput.scss';

const InlineInput = ({
  type,
  value,
  label,
  name,
  postText,
  onChange,
  required,
  disabled,
  min,
}) => (
  <span className={styles.inlineInput}>
    <label htmlFor={name}>{label}</label>
    <input
      type={type}
      value={value}
      name={name}
      onChange={onChange}
      required={required}
      disabled={disabled}
      min={min}
    />
    <span>{postText}</span>
  </span>
);

InlineInput.propTypes = {
  type: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  postText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  min: PropTypes.number,
};

InlineInput.defaultProps = {
  type: 'text',
  value: null,
  label: '',
  postText: '',
  required: false,
  disabled: false,
  min: null,
};

export default compose(
  pure(),
)(InlineInput);
